import { Component, ViewChild } from '@angular/core';
import { iBisViewComponent } from '@dohu/ibis-common';
import { ProxyService } from '../../../service/proxy.service';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { SuperAdminService } from './super-admin.service';

@Component({
	selector: 'app-super-admin',
	templateUrl: './super-admin.component.html'
})
export class SuperAdminComponent extends iBisViewComponent {
	@ViewChild('superAdminGrid') declare grid: DxDataGridComponent;

	public declare edit: SuperAdminService;

	constructor(public proxy: ProxyService) {
		super(proxy.superAdmin, proxy.lg, proxy.iui, proxy.activatedRoute);
		this.key = '[MDS]SuperAdmin';
	}

	ngOnInit(): void {
		this.edit.ensureLoaded();
	}

	onGridInit(e: any): void {
		if (this.edit.data && e.component) {
			e.component.option('dataSource', this.edit.data);
		}
	}

	toolbarPreparing(event: any): void {
		super.toolbarPreparing(event, false);
		// Stânga (before): săgeată stânga | date-box | săgeată dreapta
		event.toolbarOptions.items.unshift(
			{
				template: 'toolbarDatePrevTemplate',
				location: 'before'
			},
			{
				template: 'toolbarDateTemplate',
				location: 'before'
			},
			{
				template: 'toolbarDateNextTemplate',
				location: 'before'
			},
			{
				template: 'toolbarDoctorTemplate',
				location: 'after'
			}
		);
	}

	onFilterDateChanged(e: any): void {
		if (e.value !== undefined) {
			this.edit.selectedDate = e.value ? new Date(e.value) : new Date();
			this.edit.selectedDate.setHours(0, 0, 0, 0);
			this.applyFiltersAndRefresh();
		}
	}

	onFilterDoctorChanged(e: any): void {
		this.edit.selectedUserId = e.value ?? null;
		this.applyFiltersAndRefresh();
	}

	onDatePrev(): void {
		const d = new Date(this.edit.selectedDate);
		d.setDate(d.getDate() - 1);
		d.setHours(0, 0, 0, 0);
		this.edit.selectedDate = d;
		this.applyFiltersAndRefresh();
	}

	onDateNext(): void {
		const d = new Date(this.edit.selectedDate);
		d.setDate(d.getDate() + 1);
		d.setHours(0, 0, 0, 0);
		this.edit.selectedDate = d;
		this.applyFiltersAndRefresh();
	}

	private applyFiltersAndRefresh(): void {
		this.edit.refreshData();
		if (this.grid?.instance) {
			this.grid.instance.option('dataSource', this.edit.data);
			this.grid.instance.refresh();
		}
	}

	onRowPatientChanged(newData: any, value: any, _currentRowData: any): void {
		newData.patientId = value ?? undefined;
	}

	/** displayExpr pentru select-box pacienți: lastName + firstName */
	patientDisplayExpr = (data: any): string => {
		if (!data) return '';
		return `${data.lastName || ''} ${data.firstName || ''}`.trim();
	};
}
